// Module memory: sign up logs in before its last step, and the auth layout must not redirect it away meanwhile.
let held = false;

export const holdSignUpPage = (): void => {
  held = true;
};

export const releaseSignUpPage = (): void => {
  held = false;
};

export const isSignUpPageHeld = (): boolean => held;
